import { FC } from 'react';
import styled from 'styled-components';
import { Stack } from '@mui/material';

const StepIndicator = styled.div<{ $active: boolean }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.primary.main};
  opacity: ${({ $active }) => ($active ? 1 : 0.2)};
  transition: opacity 0.3s ease;
`;

type Props = {
  nrOfSteps: number;
  currentStepIndex: number;
};

const StepperIndicator: FC<Props> = ({ nrOfSteps, currentStepIndex }) => (
  <Stack direction="row" gap={1}>
    {Array.from({ length: nrOfSteps }).map((_, index) => (
      <StepIndicator $active={index === currentStepIndex} key={index} />
    ))}
  </Stack>
);

export default StepperIndicator;
